import moment from 'moment';

export default class Chat {
    name = "";
    type = "";
    messages = [];
    count = 0;
    dateCreated = new Date().toISOString().substr(0, 10);
    users = [];
    orgId = "";
    read = [];
 
    constructor(Name, Type, Messages, Count, DateCreated, Users, OrgId, Read) 
    {
      //Used Tenary operator to determine whether anything was entered/the parameter is defined. If not, set as the default  
      Name ? this.name = Name : this.name = "";
      Type ? this.type = Type : this.type = "";
      Messages ? this.messages = Messages : this.messages = [{content: "Chat Created", date: moment().format('MM-DD-YYYY hh:mm A'), uid: null}];
      Count ? this.count = Count : this.count = 0;
      DateCreated ? this.dateCreated = DateCreated : this.dateCreated = moment().format('MM-DD-YYYY hh:mm A');
      Users ? this.users = Users : this.users = [];
      OrgId ? this.orgId = OrgId : this.orgId = "";
      Read ? this.read = Read : this.read = [];
    }

    async validateMessage(rules, newMessage){
        console.log("Will check " + rules + "against" + newMessage); //eslint-disable-line

        if (!newMessage){
          return false;
        }

        return true;
     } 
}